import PptxGenJS from 'pptxgenjs'
import { requestTranslation as tr } from '@futures-platform/i18n'
import radarDataApi from '@futures-platform/connectors/radar-data-api'
import { getPhenomenaTypes, getRadar } from '@futures-platform/connectors/drupal-api'
import { getUsername } from '@futures-platform/connectors/session'
import htmlToText from 'html-to-text'
import { getRadarPhenomena } from '@futures-platform/connectors/phenomena-api'
import { get } from 'lodash'
import { screenshot } from '@futures-platform/connectors/screenshot-service-api'
import { ratingApi } from './helpers/fetcher';
import { getGroupInitials, getInitialsColor, getInitialsFontScale } from './helpers/groupInitials'
export default async function generatePPTX(radarId, groupId, isFlipFlag, { public_groups = [], private_groups = [], publicPhenomenaGroups = [] } = {}) {
  const pptx = new PptxGenJS()
  const username = getUsername()
  const reportCreatedDate = new Date()
  const createdDate = reportCreatedDate.toLocaleDateString()
  const phenomenonTypes = await getPhenomenaTypes(groupId)
  const phenomenonTypeTitlesById = phenomenonTypes.reduce((obj, { id, title }) => ({ ...obj, [id]: title }), {})
  const phenomenonTypesByKey = phenomenonTypes.reduce((obj, type) => {
    if (type.id != null) obj[String(type.id)] = type
    if (type.alias) obj[String(type.alias)] = type
    if (type.name) obj[String(type.name)] = type
    return obj
  }, {})
  const {
    radarName,
    results_url: radarResultsUrl,
    url: radarUrl,
    phenomena: radarPhenomenaDataById,
    axisXTitle,
    axisYTitle,
    axisXMin,
    axisXMax,
    axisYMin,
    axisYMax,
    fourFieldsTopLeft,
    fourFieldsTopRight,
    fourFieldsBottomLeft,
    fourFieldsBottomRight,
    comment_count,
    ratingsOn,
    votingOn,
    discussionOn,
    commentsOn
  } = await getRadar(radarId)
  const { data: { sectors } } = await radarDataApi.getRadar(radarId)
  const { phenomena: radarPhenomena } = await getRadarPhenomena(radarId, groupId, {
                public_groups: [0,...public_groups],
                private_groups: private_groups,
            })
  const [ratingsData, votingsData] = await Promise.all([
    ratingApi.getAllRatings(groupId, radarId),
    ratingApi.getAllVotes(groupId, radarId)
  ])
  const {data: ratingsObj} =  ratingsData
  const {data: votingsObj} =  votingsData

  // const ratings = Object.entries(ratingsObj)
  // const votings = Object.entries(votingsObj)
  
  let phenomena = radarPhenomena.map(p => ({ ...radarPhenomenaDataById[p.id], ...p })).sort(({ time: aTime }, { time: bTime }) => aTime - bTime)
  Object.keys(votingsObj).map(async (phe) => {
    const pheURL = String(Object.keys(votingsObj[phe]));
    const pheId = pheURL.split('/');

    phenomena && !!phenomena.length && phenomena.forEach(phenomenon => {
        if (votingsObj[phe][`/${groupId}/radar/${radarId}/phenomenon/${pheId[5]}`] && phenomenon.id === pheId[5]) {
            phenomenon['vote_sum'] = Number(votingsObj[phe]?.[`/${groupId}/radar/${radarId}/phenomenon/${pheId[5]}`]?.sum)
        }
    });
  });

  Object.keys(ratingsObj).map( async(phe) => {
    const pheId = phe.split('/')
    !!phenomena?.length && phenomena.forEach(phenomenon => { 
        if(String(phenomenon?.id) === String(pheId[5]) && String(pheId[6]) ==='x') {
          if (!phenomenon['rating_avg'] || phenomenon['rating_avg'] ===     undefined) 
            phenomenon['rating_avg'] = {}
          phenomenon['rating_avg']['x'] = Number(ratingsObj[phe]?.avg)
        }
        if(String(phenomenon?.id) === String(pheId[5]) && String(pheId[6]) ==='y') {
          if (!phenomenon['rating_avg'] || phenomenon['rating_avg'] ===     undefined) phenomenon['rating_avg'] = {}
            phenomenon['rating_avg']['y'] = Number(ratingsObj[phe]?.avg)
        }
    })
})
  pptx.defineLayout({ name: 'FP', width: 13.33, height: 7.5 });
  pptx.layout = 'FP';
  pptx.defineSlideMaster({
    title: "FP_SLIDE",
    // slideNumber: { x: 10, y: 7.8, color: '000000' },
    objects: [
      {
        image: {
          x: 0.37,
          y: 7.02,
          w: 2.17,
          h: 0.32,
          data: getFuturesPlatformLogo()
        },
      },
      {
        text: {
          text: `${createdDate}  ${tr('pptxReportBy')} ${username}`, options: { x: 4, y: 7.04, w: 9.0, h: 0.3, fontSize:12, align: 'right' }
        }
      }
    ]
  })

  function addHeading(txt, slide) {
    slide.addText(txt, { x: 0.4, y: 0.4, fontSize: 18, valign: "top", w: 12, h: 0.4 })
  }

  function addTitle(txt, slide) {
    // Calculate dynamic height based on title length
    const titleHeight = calculateTitleHeight(txt)
    slide.addText(txt, { x: 0.4, y: 0.68, fontSize: 25, color: '44546a', bold: true, valign: "top", w: 12, h: titleHeight })
    return titleHeight
  }

  function calculateTitleHeight(txt) {
    // Estimate characters per line (approximately 50-60 chars at fontSize 25 with width 12)
    const charsPerLine = 55
    const lines = Math.ceil(txt.length / charsPerLine)
    // Base height per line (0.3) + some padding
    return Math.max(0.5, lines * 0.35)
  }

  function addSlide(opts = {}) {
    return pptx.addSlide(Object.assign({
      masterName: "FP_SLIDE",
      fontFace: 'Arial',
      fontSize: 12
    }, opts))
  }

  function addCoverSlide() {
    const slide = addSlide({
      masterName: undefined
    })
    // Radar Title
    slide.addText(radarName, { x: 0.16, y: 2.57, w: 13, h: 1.63, autoShrink: true, align: 'center', bold: true, fontSize: 50 })
    // Content Summary Text
    slide.addText([
      { text: `${tr('pptxReportTitle')} `, options: { bold: true, breakLine: false } },
      { text: createdDate, options: { breakLine: false } },
      { text: ` ${tr('pptxReportBy')} `, options: { bold: true, breakLine: false } },
      { text: username, options: { breakLine: false } },
    ], { x: 0.16, y: 4.24, w: 13, h: 2, fontSize: 20, align: 'center', color: '44546a' })
    slide.addImage({
      x: 4.7,
      y: 6.5,
      w: 3.92,
      h: 0.59,
      data: getFuturesPlatformLogo()
    })
  }

  async function addPreviewSlide() {
    const slide = addSlide({ masterName: undefined })
    try {
      const { data } = await screenshot({ url: radarUrl, waitFor: 12000 })
      slide.addImage({
        data: `image/png;base64,${data}`,
        x: 0,
        y: 0,
        w: 13.33,
        h: 7.5
      })
    } catch (err) {
      console.error('radar preview screenshot failed')
    }
  }

  function addSectorsSlide() {
    const slide = addSlide()
    addHeading(radarName, slide)
    const titleHeight = addTitle(tr('pptxSectorListTitle'), slide)
    // Adjust content position based on title height with more spacing
    const contentY = 0.68 + titleHeight + 0.2
    const contentHeight = 6.8 - contentY
    slide.addText(sectors.map(({title}) => ({
      text: title, options: { bullet: true }
    })), { x: 0.4, y: contentY, fontSize: 15, lineSpacing: 30, valign:"top", w: 12, h: contentHeight })
  }

  function addSectorSummarySlide({ title, notes }) {
    const slide = addSlide()
    addHeading(tr('pptxSector').toUpperCase(), slide)
    const titleHeight = addTitle(title, slide)
    // Adjust content position based on title height with more spacing
    const contentY = 0.68 + titleHeight + 0.2 // title start + title height + larger gap
    const contentHeight = 6.8 - contentY // available space until footer
    slide.addText(toText(notes), { x: 0.4, y: contentY, w: 11.5, h: contentHeight, fontSize: 12, isTextBox: true, shrinkText: true, valign: 'top' })
  }

  function addSectorContent(id, title, phenomena) {
    const slide = addSlide()
    addHeading(tr('pptxSectorContent').toUpperCase(), slide)
    const titleHeight = addTitle(title, slide)
    let xOffset = 0
    
    // Calculate dynamic positioning based on title height with more spacing
    const baseY = 0.68 + titleHeight + 0.2 // title start + title height + larger gap
    const phenomenaTitleY = baseY
    const phenomenaTypeY = baseY + 0.4
    const timestampY = baseY + 0.7
    const summaryY = baseY + 1.0
    const summaryHeight = 6.8 - summaryY // available space until footer

    // TODO: Replace time with crowdsourced
    phenomena.forEach(({ content: { short_title, title, type, summary, time_range }, time }) => {
      const yearMin = time_range?.min
      const yearMax = time_range?.max
      let timeRangeStr = ''
      if (yearMin || yearMax) {
        timeRangeStr = `${yearMin}-${yearMax}`
      }

      slide.addText((short_title === '' || !short_title?.length) ? (title.length > 37 ? title.substring(0, 34) + '...' : title) : short_title, { x: 0.4 + xOffset, y: phenomenaTitleY, w: 3.9, h: 0.3, isTextBox: true, shrinkText: true, bold: true, fontSize: 15 })
      slide.addText(`${phenomenonTypeTitlesById[type]} ${timeRangeStr}`, { x: 0.4 + xOffset, y: phenomenaTypeY, w: 3.9, h: 0.25, shrinkText: true, fontSize: 10 })
      slide.addText(`${tr('pptxTimestamp')}: ${Math.trunc(time) || '-'}`, { x: 0.4 + xOffset, y: timestampY, w: 3.9, h: 0.25, shrinkText: true, fontSize: 10 })
      slide.addText(toText(summary), { x: 0.4 + xOffset, y: summaryY, w: 3.9, h: summaryHeight, isTextBox: true, shrinkText: true, valign: 'top', fontSize: 12 })
      xOffset += 4
    })

  }

  function addTopVotedContentSlide(phenomena, pageNum, totalCount) {
    const slide = addSlide()
    addHeading(radarName, slide)
    const titleHeight = addTitle(tr('pptxTopVotedContent'), slide)

    // const votedPhenFiltered = phenomena.filter(p => )
    const rows = phenomena.map(({ content: { short_title, title, type }, vote_sum }) => {
      if ( vote_sum !== null && Number(vote_sum) === 0) {
        return (
          [
            { text: short_title || title, options: { bold: true } },
            { text: `${phenomenonTypeTitlesById[type]}` },
            { text: "0"}
          ]
        )
      } else {
        return (
          [
            { text: short_title || title, options: { bold: true } },
            { text: `${phenomenonTypeTitlesById[type]}` },
            { text: typeof vote_sum === 'number' ? vote_sum : '-' }
          ]
        )
      }
      
    })
    // Adjust table position based on title height with more spacing
    const tableY = 0.68 + titleHeight + 0.2
    const tableHeight = 6.8 - tableY
    slide.addTable(rows, { x: 0.5, y: tableY, w: 12, h: tableHeight, colW: [8, 1.5, 1.5], valign: 'top' })
  }

  function getFlippedRating(ratingAvg) {
    if (!ratingAvg) {
      return null
    }
    if (isFlipFlag) {
      return {
        x: ratingAvg.y,
        y: ratingAvg.x
      }
    }
    return ratingAvg
  }

  async function addRatedContentChartSlide() {
    const fpWatermark = await loadFpWatermarkPptxData()
    const slide = addSlide()
    addHeading(radarName, slide)
    const titleHeight = addTitle(tr('pptxRatedContent'), slide)
    const axes = {
      xTitle: axisXTitle,
      yTitle: axisYTitle,
      xMin: axisXMin,
      xMax: axisXMax,
      yMin: axisYMin,
      yMax: axisYMax
    }
    const plotX = 2.15
    const plotY = 0.68 + titleHeight + 0.35
    const plotW = 8.7
    const plotH = 6.35 - plotY
    const ratedPhenomena = phenomena.filter(({ rating_avg }) => {
      const rating = getFlippedRating(rating_avg)
      return rating && Number.isFinite(rating.x) && Number.isFinite(rating.y)
    })
    const dotSize = ratedPhenomena.length > 80 ? 0.14 : ratedPhenomena.length > 40 ? 0.18 : 0.24
    const labelFontSize = ratedPhenomena.length > 80 ? 8 : 10
    const maxLabelChars = 48
    const labelW = 1.7
    const labelH = 0.36

    slide.addShape('rect', {
      x: plotX,
      y: plotY,
      w: plotW,
      h: plotH,
      fill: { color: 'FFFFFF' },
      line: { color: '979797', width: 1 }
    })
    slide.addShape('line', {
      x: plotX,
      y: plotY + plotH / 2,
      w: plotW,
      h: 0,
      line: { color: 'C8CDD2', width: 1 }
    })
    slide.addShape('line', {
      x: plotX + plotW / 2,
      y: plotY,
      w: 0,
      h: plotH,
      line: { color: 'C8CDD2', width: 1 }
    })

    const quadrantPad = 0.08
    const quadrantW = plotW / 2 - 0.16
    const quadrantH = 0.28
    const quadrantStyle = { fontSize: 10, color: '637282', italic: true, valign: 'top' }
    slide.addText(fourFieldsTopLeft || '', { x: plotX + quadrantPad, y: plotY + quadrantPad, w: quadrantW, h: quadrantH, ...quadrantStyle })
    slide.addText(fourFieldsTopRight || '', { x: plotX + plotW / 2 + 0.08, y: plotY + quadrantPad, w: quadrantW, h: quadrantH, align: 'right', ...quadrantStyle })
    slide.addText(fourFieldsBottomLeft || '', { x: plotX + quadrantPad, y: plotY + plotH - quadrantH - quadrantPad, w: quadrantW, h: quadrantH, valign: 'bottom', fontSize: 10, color: '637282', italic: true })
    slide.addText(fourFieldsBottomRight || '', { x: plotX + plotW / 2 + 0.08, y: plotY + plotH - quadrantH - quadrantPad, w: quadrantW, h: quadrantH, align: 'right', valign: 'bottom', fontSize: 10, color: '637282', italic: true })

    ratedPhenomena.forEach((phenomenon) => {
      const rating = getFlippedRating(phenomenon.rating_avg)
      const xRatio = Math.min(1, Math.max(0, Number(rating.x) / 100))
      const yRatio = Math.min(1, Math.max(0, Number(rating.y) / 100))
      const cx = plotX + xRatio * plotW
      const cy = plotY + (1 - yRatio) * plotH
      slide.addShape('ellipse', {
        x: cx - dotSize / 2,
        y: cy - dotSize / 2,
        w: dotSize,
        h: dotSize,
        fill: { color: getPhenomenonChartColor(phenomenon, phenomenonTypesByKey) },
        line: { color: 'FFFFFF', width: 0.75 }
      })
      if (isFpPhenomenon(phenomenon) && fpWatermark) {
        const typeKey = phenomenon.content && phenomenon.content.type != null
          ? String(phenomenon.content.type)
          : ''
        const typeObj = (typeKey && phenomenonTypesByKey[typeKey])
          || phenomenonTypesByKey.undefined
        const isUndefined = !typeObj || typeObj.alias === 'undefined'
        const markSize = isUndefined ? dotSize / 2 : dotSize
        slide.addImage({
          data: fpWatermark,
          x: cx - markSize / 2,
          y: cy - markSize / 2,
          w: markSize,
          h: markSize
        })
      }
      const groupInitials = getGroupInitials(
        phenomenon && phenomenon.group,
        publicPhenomenaGroups
      )
      if (groupInitials) {
        const typeAlias = getPhenomenonTypeAlias(phenomenon, phenomenonTypesByKey)
        slide.addText(groupInitials, {
          x: cx - dotSize / 2,
          y: cy - dotSize / 2,
          w: dotSize,
          h: dotSize,
          fontSize: Math.max(5, Math.round(dotSize * 36 * getInitialsFontScale(typeAlias))),
          bold: true,
          color: getInitialsColor(typeAlias).replace('#', ''),
          align: 'center',
          valign: 'middle',
          margin: 0
        })
      }
      const content = phenomenon.content || {}
      const rawName = String(content.short_title || '').trim() || String(content.title || '').trim()
      const label = truncatePhenLabel(rawName, maxLabelChars)
      if (!label) {
        return
      }
      const labelX = Math.min(
        Math.max(cx - labelW / 2, plotX + 0.04),
        plotX + plotW - labelW - 0.04
      )
      const gap = 0.04
      const fitsBelow = cy + dotSize / 2 + gap + labelH <= plotY + plotH - 0.02
      const labelY = fitsBelow
        ? cy + dotSize / 2 + gap
        : cy - dotSize / 2 - gap - labelH
      slide.addText(label, {
        x: labelX,
        y: labelY,
        w: labelW,
        h: labelH,
        fontSize: labelFontSize,
        color: '121212',
        valign: 'top',
        align: 'center',
        margin: 0
      })
    })

    slide.addText(axes.yMax || '', { x: 0.52, y: plotY, w: 1.55, h: 0.28, fontSize: 10, color: '637282', align: 'right' })
    slide.addText(axes.yTitle || '', {
      x: 0.08,
      y: plotY,
      w: 0.42,
      h: plotH,
      fontSize: 12,
      bold: true,
      align: 'center',
      valign: 'middle',
      vert: 'eaVert'
    })
    slide.addText(axes.yMin || '', { x: 0.52, y: plotY + plotH - 0.28, w: 1.55, h: 0.28, fontSize: 10, color: '637282', align: 'right', valign: 'bottom' })
    slide.addText(axes.xMin || '', { x: plotX, y: plotY + plotH + 0.04, w: plotW / 2, h: 0.22, fontSize: 10, color: '637282' })
    slide.addText(axes.xMax || '', { x: plotX + plotW / 2, y: plotY + plotH + 0.04, w: plotW / 2, h: 0.22, fontSize: 10, color: '637282', align: 'right' })
    slide.addText(axes.xTitle || '', { x: plotX, y: plotY + plotH + 0.24, w: plotW, h: 0.28, fontSize: 12, bold: true, align: 'center' })
  }

  function addRatedContentAxisSlide(xPhenomena, yPhenomena, pageNum, totalPages) {
    const slide = addSlide()
    addHeading(radarName, slide)
    const ratedTitle = totalPages > 1
      ? `${tr('pptxRatedContent')} (${pageNum}/${totalPages})`
      : tr('pptxRatedContent')
    const titleHeight = addTitle(ratedTitle, slide)

    // Calculate dynamic positioning based on title height with more spacing
    const axisTitleY = 0.68 + titleHeight + 0.2
    const tableY = axisTitleY + 0.4
    const tableHeight = 6.8 - tableY

    let xOffset = 0.4;
    [xPhenomena, yPhenomena].forEach(({ title, axis, phenomena }) => {
      slide.addText(title, { x: xOffset, y: axisTitleY, fontSize: 18, w: 6.2, h: 0.3, bold: true })
      const rows = phenomena.map(({ content: { short_title, title, type }, rating_avg }) => {
        const convert_rating_avg_afterFlipping = getFlippedRating(rating_avg)
        return [
          { text: short_title || title, options: { bold: true } },
          { text: `${phenomenonTypeTitlesById[type]}` },
          { text: convert_rating_avg_afterFlipping && typeof convert_rating_avg_afterFlipping[axis] === 'number' ? (convert_rating_avg_afterFlipping[axis] / 100).toFixed(2) : '-' }
        ]
      })
      if (rows.length > 0) {
        slide.addTable(rows, { x: xOffset, y: tableY, w: 5.5, h: tableHeight, colW: [3.5, 1.5, 0.5], valign: 'top' })
      }
      xOffset += 6.8
    })
  }

  function addCommentSummarySlide() {
    const slide = addSlide()
    addHeading(radarName, slide)
    const titleHeight = addTitle(tr('pptxCommentsTitle'), slide)

    // Adjust content position based on title height with extra spacing (like rated section table)
    const contentY = 0.68 + titleHeight + 0.2 + 0.4
    
    slide.addText([
      // {text: tr('pptxCommentsText', comment_count) , options: { breakLine: false }},
      {text: tr('pptxCommentsText') , options: { breakLine: false }},
      {text: `${radarResultsUrl}#comments`, options: { hyperlink: {url: `${radarResultsUrl}#comments` }}}
    ], { x: 0.4, y: contentY })
  }

  addCoverSlide()
  await addPreviewSlide()

  // Sectors
  addSectorsSlide()
  sectors.forEach(function (sector) {
    addSectorSummarySlide(sector)
    let sectorPhenomena = phenomena.filter(({ sectorId }) => sectorId === sector.id)
    do {
      addSectorContent(sector.id, sector.title, sectorPhenomena.splice(0, 3))
    } while (sectorPhenomena.length > 0)
  })

  // Top Voted Phenomena
  if (votingOn) {
    const sortedPhenomena = [...phenomena].sort(({ vote_sum: aVoteSum = -1000000, time: aTimestamp }, { vote_sum: bVoteSum = -1000000, time: bTimestamp }) => {
      if (aVoteSum === bVoteSum) {
        return aTimestamp-bTimestamp
      }
      return bVoteSum-aVoteSum
    })

    const votedPhenFitlered = sortedPhenomena.length > 0 && 
      sortedPhenomena.filter(p => p.vote_sum !== null)
      .sort((a, b) => {
        return Number(b.vote_sum) - Number(a.vote_sum)
      })
      .sort((a, b) =>{
        if (Number(b.vote_sum) - Number(a.vote_sum) == 0) 
            return a.content?.title.localeCompare(b.content?.title)
      })

      
    const nonVotedPhenFitlered = sortedPhenomena.length > 0 && sortedPhenomena.filter(p => p.vote_sum === null)
      .sort((a, b) => a.content?.title.localeCompare(b.content?.title))

    const sortedPhenFinally = votedPhenFitlered.concat(nonVotedPhenFitlered)
    const topVotedPageCount = Math.ceil(sortedPhenFinally.length % 15)
    let topVotedPageNum = 1
    do {
      addTopVotedContentSlide(sortedPhenFinally.splice(0, 15), topVotedPageCount, topVotedPageNum++, topVotedPageCount)
    } while (sortedPhenFinally.length > 0)
  }

  // Content Rating
  if (ratingsOn) {
    await addRatedContentChartSlide()

    const axisPhenomena = ['x', 'y'].map(axis => [...phenomena].sort(({ rating_avg: aRatingAvg }, { rating_avg: bRatingAvg }) => {
      const aRating = getFlippedRating(aRatingAvg)
      const bRating = getFlippedRating(bRatingAvg)
      let aAvg = get(aRating, axis, -10000000)
      let bAvg = get(bRating, axis, -10000000)
      return bAvg-aAvg
    }))
    let xPhenomena = axisPhenomena[0] || []
    let yPhenomena = axisPhenomena[1] || []
    const RATED_ROWS_PER_SLIDE = 14
    const ratedTablePages = Math.max(
      Math.ceil(xPhenomena.length / RATED_ROWS_PER_SLIDE),
      Math.ceil(yPhenomena.length / RATED_ROWS_PER_SLIDE),
      1
    )
    const tableAxisXTitle = axisXTitle
    const tableAxisYTitle = axisYTitle
    let ratedTablePage = 1
    do {
      addRatedContentAxisSlide(
        { title: tableAxisXTitle, axis: 'x', phenomena: xPhenomena.length > 0 ? xPhenomena.splice(0, RATED_ROWS_PER_SLIDE) : [] },
        { title: tableAxisYTitle, axis: 'y', phenomena: yPhenomena.length > 0 ? yPhenomena.splice(0, RATED_ROWS_PER_SLIDE) : [] },
        ratedTablePage,
        ratedTablePages
      )
      ratedTablePage += 1
    } while (xPhenomena.length > 0 || yPhenomena.length > 0)
  }

  if (discussionOn || commentsOn) {
    // Comment Summary Slide
    addCommentSummarySlide()
  }
  return pptx.writeFile(radarName.replace(/(\W+)/gi, '-'));
}

function cssColorToHex(color) {
  if (!color || typeof color !== 'string') {
    return null
  }
  if (color.charAt(0) === '#') {
    const hex = color.replace('#', '').slice(0, 6).toUpperCase()
    return hex.length === 6 ? hex : null
  }
  const rgb = color.match(/rgba?\(\s*(\d+)\s*,\s*(\d+)\s*,\s*(\d+)/)
  if (rgb) {
    return [rgb[1], rgb[2], rgb[3]]
      .map((value) => Number(value).toString(16).padStart(2, '0'))
      .join('')
      .toUpperCase()
  }
  return null
}

const PHENOMENON_TYPE_COLORS_BY_ALIAS = {
  rising: '00CA8D',
  cooling: '0098FF',
  weakening: '0098FF',
  wildcard: 'E95757',
  undefined: '00CA8D',
  client: '00CA8D',
  weaksignal: 'A8A8A8',
  summary: '58C692',
  established: '016998'
}

function isFpPhenomenon(phenomenon) {
  return Number(phenomenon && phenomenon.group) === 0
    || (!!(phenomenon && phenomenon.groups && phenomenon.groups.length)
      && Number(phenomenon.groups[0]) === 0)
}

function getPhenomenonTypeAlias(phenomenon, typesByKey) {
  const rawType = phenomenon && phenomenon.content && phenomenon.content.type
  const typeKey = rawType != null ? String(rawType) : ''
  const typeObj = (typeKey && typesByKey[typeKey]) || typesByKey.undefined || null
  const alias = typeObj && typeObj.alias
    ? String(typeObj.alias).replace(/\s/g, '')
    : typeKey.replace(/\s/g, '')
  return alias || 'undefined'
}

function getFpWatermarkSvgData() {
  const svg = '<svg width="9" height="6" viewBox="0 0 9 6" fill="none" xmlns="http://www.w3.org/2000/svg"><g opacity="0.85"><path fill-rule="evenodd" clip-rule="evenodd" d="M5.22104 5.88832C4.59765 5.86654 4.47944 4.32967 4.49004 2.8889C4.5022 1.35459 4.70784 0.711346 5.12016 0.486851C5.41892 0.323861 6.41816 0.386135 6.46654 0.389211C7.83748 0.474806 8.375 1.39124 8.375 2.23925C8.375 3.91656 7.39387 4.0593 6.55914 4.57928C5.88427 4.99957 5.84883 5.88832 5.22104 5.88832Z" fill="#FFFFFF"/><path fill-rule="evenodd" clip-rule="evenodd" d="M3.92443 0.990553C3.91848 0.520548 3.58247 0.440847 3.20119 0.407019C2.85302 0.375498 1.7917 0.355252 1.30281 0.430084C0.620962 0.535412 0.521115 1.68172 0.502232 2.93823C0.481539 4.34594 0.596129 5.84821 1.20943 5.88717C1.21332 5.88717 1.2172 5.88794 1.22082 5.88794C1.43318 5.89537 1.58011 5.80234 1.7022 5.6619C1.8812 5.45611 2.00484 5.14731 2.20505 4.90103C2.57107 4.45178 2.82121 4.33108 3.21024 4.0033C3.80311 3.50383 3.50435 2.88723 3.51729 2.4162C3.52711 2.07151 3.6386 1.84471 3.68775 1.7463C3.85847 1.4029 3.92676 1.18506 3.92443 0.990553Z" fill="#FFFFFF"/></g></svg>'
  return `image/svg+xml;base64,${btoa(svg)}`
}

async function loadFpWatermarkPptxData() {
  try {
    const response = await fetch('https://go2.futuresplatform.com/sites/default/files/watermark-fp.png')
    if (!response.ok) {
      return getFpWatermarkSvgData()
    }
    const bytes = new Uint8Array(await response.arrayBuffer())
    let binary = ''
    for (let i = 0; i < bytes.length; i += 1) {
      binary += String.fromCharCode(bytes[i])
    }
    return `image/png;base64,${btoa(binary)}`
  } catch (err) {
    return getFpWatermarkSvgData()
  }
}

function truncatePhenLabel(text, maxChars) {
  const label = String(text || '').trim()
  if (!label) {
    return ''
  }
  if (label.length <= maxChars) {
    return label
  }
  return `${label.substring(0, maxChars - 1)}…`
}

function getPhenomenonChartColor(phenomenon, typesByKey) {
  const rawType = phenomenon && phenomenon.content && phenomenon.content.type
  const typeKey = rawType != null ? String(rawType) : ''
  const typeObj = (typeKey && typesByKey[typeKey]) || null
  const fromStyle = cssColorToHex(typeObj && typeObj.style && typeObj.style.color)
  if (fromStyle) {
    return fromStyle
  }
  const alias = typeObj && typeObj.alias
    ? String(typeObj.alias).replace(/\s/g, '')
    : typeKey.replace(/\s/g, '')
  return PHENOMENON_TYPE_COLORS_BY_ALIAS[alias] || PHENOMENON_TYPE_COLORS_BY_ALIAS.rising
}

function toText(html) {
  return htmlToText.fromString(html, { wordwrap: false, ignoreImage: true, singleNewLineParagraphs: false }).replace("\r", '').replace(/\n\n+/g, "\n\n")
}

function getFuturesPlatformLogo() {
  return 'image/wmf;base64,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'
}